import React, { ReactNode } from "react";

import { FormSubmissionContext } from "./FormSubmitContext";
import { useFormSubmission } from "./hooks";

interface FormSubmissionProviderProps {
  children: ReactNode;
}

export const FormSubmissionProvider: React.FC<FormSubmissionProviderProps> = ({
  children,
}) => {
  const formSubmission = useFormSubmission();

  // Create the context value with isPerformingInitialReset set to false
  // This property will be managed by FormEngineProvider when needed
  const contextValue = {
    ...formSubmission,
    isPerformingInitialReset: false,
  };

  return (
    <FormSubmissionContext.Provider value={contextValue}>
      {children}
    </FormSubmissionContext.Provider>
  );
};
